import { jsx as o } from "react/jsx-runtime";
import { SvgIcon as h } from "../SvgIcon.js";
const V = (c) => /* @__PURE__ */ o(h, { ...c, children: /* @__PURE__ */ o("path", { d: "M4.40251 6.25876H14.5988v1.68999H4.40251V6.25876Zm0 3.40252h8.50629v1.69002H4.40251V9.66128ZM18.0013 4.55751v-.85626C18.0013 2.76612 17.2351 2 16.3 2H2.70125C1.76613 2 1 2.75486 1 3.70125V13.8975c0 .9351.76613 1.7013 1.70125 1.7013h5.10377L12.0525 18.99v-3.4025h4.2363c.9351 0 1.7012-.7661 1.7012-1.7013l.0113-9.32869ZM16.3 13.8975h-5.9262V15.4974l-1.99419-1.5999H2.70125V3.70125H16.3V13.8975Z" }) });
export {
  V as Topic
};
//# sourceMappingURL=Topic.js.map
